export default "__VITE_ASSET__06c9e267__"